import { useSelector } from "react-redux";
import {
  CenteredInput,
  ZipScreenImage,
  ModernSmContainer,
  CenteredInputLabel,
  CenteredInnerContainer,
  CenteredUserPromptContainer
} from "../ModernVariant.styles";
import { useZipcodeAction } from "../../../hooks/useZipcodeAction";
import { useCountryOption } from "../../../hooks/useCountryOption";
import { POSTAL_CODE_INPUT_PROPS } from "../../../services/form-fields";

const ModernZipComponent = ({ onSubmit }) => {
  const zipInfo = useSelector((state) => state.zipInfo);
  const { funnel } = useSelector((state) => state.funnelInfo);
  const { handleUpdateZip, mapImageSrc, postalCodeLengths, isPostalCodeValid } =
    useZipcodeAction();
  // Loads the funnel country option once for this screen
  useCountryOption();

  return (
    <ModernSmContainer>
      <CenteredUserPromptContainer
        $forZip={true}
        className="mt-5 mx-auto bg-white text-center d-flex flex-column justify-content-center align-items-center position-relative"
      >
        <CenteredInnerContainer className="d-flex flex-wrap justify-content-between">
          <div className="d-flex flex-fill align-items-center gap-2 gap-md-3 flex-column flex-md-row">
            <ZipScreenImage src={mapImageSrc} alt="map" />
            {/* A form, so Enter / the keyboard's "Weiter" key submits */}
            <form
              className="w-100 text-start"
              noValidate
              onSubmit={(event) => {
                event.preventDefault();
                if (isPostalCodeValid) onSubmit();
              }}
            >
              <CenteredInputLabel htmlFor="postalCode" className="mt-0">
                {funnel.textElements?.zipCodeScreen || "Postleitzahl"}
              </CenteredInputLabel>
              <CenteredInput
                {...POSTAL_CODE_INPUT_PROPS}
                id="postalCode"
                enterKeyHint="next"
                maxLength={Math.max(...postalCodeLengths)}
                value={zipInfo.value}
                placeholder="Postleitzahl eingeben"
                onChange={({ target: { value } }) => handleUpdateZip({ value })}
              />
            </form>
          </div>
        </CenteredInnerContainer>
      </CenteredUserPromptContainer>
    </ModernSmContainer>
  );
};
export default ModernZipComponent;
